import { signOut } from 'firebase/auth';
import { useCallback } from 'react';

import { logout, useAppDispatch } from '../state';
import { message } from '../ui/message';

const useSignOut = ({
  source,
  eventName = 'login_out_click',
}: {
  source: string;
  eventName?: string;
}) => {
  const dispatch = useAppDispatch();
  const onSignOut = useCallback(async () => {
    const { auth } = await import('../utils/firebase');
    signOut(auth)
      .then(async () => {
        await dispatch(logout());
        // await dispatch(anonymousLogin({}));
      })
      .catch((e) => {
        console.error('sign out error %o', e);
        message.success('sign out failed');
      })
      .finally(() => {
        // location.href = '/login';
      });
  }, [dispatch]);

  return { onSignOut };
};

export { useSignOut };
